import type { RestService } from '@sydle/ui-api';
import { CustomAPI } from '@sydle/ui-api';

const FILTER_API_CLASS_ID = '6647a4799f4aee65f5e33f80';

export class FilterAPI {
  private filterAPI: CustomAPI;

  constructor(restService: RestService) {
    this.filterAPI = new CustomAPI(FILTER_API_CLASS_ID, restService);
  }

  public async getOperators(input: any): Promise<any> {
    return this.filterAPI.fetch('getOperators', { ...input }, {});
  }
}
